export default "__VITE_ASSET__DYMfnjBP__"